import { valueOf } from "@/types/common";

export const USER_TYPE = {
  ADMIN: "admin",
  ADMIN_MEMBER: "admin_member",
  COMPANY_USER: "company_user",
};

export type TUserType = valueOf<typeof USER_TYPE>;

export const ADMIN_ROLE = {
  MANAGER: "manager",
  SALE: "company_sale",
  CUSTOM_SERVICE: "custom_service",
  AUDITOR: "auditor",
};

export type TAdminRole = valueOf<typeof ADMIN_ROLE>;

// Customer (organization) user roles — 管理者 / 一般 . Matches BE EUserRole.
export const USER_ROLE = {
  ADMIN: "admin",
  MEMBER: "member",
} as const;

export type TUserRole = valueOf<typeof USER_ROLE>;

export const USER_ROLE_LABEL: Record<TUserRole, string> = {
  [USER_ROLE.ADMIN]: "管理者",
  [USER_ROLE.MEMBER]: "一般",
};

// Customer user status — 使用中 / 停止中. Matches BE EUserStatus.
export const USER_STATUS = {
  ACTIVE: "active",
  DISABLED: "disabled",
} as const;

export type TUserStatus = valueOf<typeof USER_STATUS>;

// Status labels per spec sheet (list badge + detail/edit dropdown): 使用中 / 停止中.
export const USER_STATUS_LABEL: Record<TUserStatus, string> = {
  [USER_STATUS.ACTIVE]: "使用中",
  [USER_STATUS.DISABLED]: "停止中",
};

// Customer user authentication status (認証ステータス). Matches BE EAccountStatus.
export const USER_ACCOUNT_STATUS = {
  INVITATION_SENT: "invitation_sent",
  ACCOUNT_CONFIGURED: "account_configured",
  PASSWORD_RESET: "password_reset",
  SUSPENDED: "suspended",
} as const;

export type TUserAccountStatus = valueOf<typeof USER_ACCOUNT_STATUS>;

export const USER_ACCOUNT_STATUS_LABEL: Record<TUserAccountStatus, string> = {
  [USER_ACCOUNT_STATUS.INVITATION_SENT]: "登録メール送付済み",
  [USER_ACCOUNT_STATUS.ACCOUNT_CONFIGURED]: "アカウント設定済み",
  [USER_ACCOUNT_STATUS.PASSWORD_RESET]: "パスワードリセット済み",
  [USER_ACCOUNT_STATUS.SUSPENDED]: "ユーザー停止中",
};

export const GENDER = {
  MALE: "male",
  FEMALE: "female",
} as const;

export type TGender = valueOf<typeof GENDER>;

export const MAINTENANCE_MODE = {
  SYSTEM_NORMAL_OPERATION: "system_normal_operation",
  MAINTENANCE_READABLE: "maintenance_readable",
  MAINTENANCE_UNUSABLE: "maintenance_unusable",
};

export const CHECK_PDF_RESULT = {
  OK: "ok",
  INVALID: "invalid",
  PASSWORD_PROTECTED: "password-protected",
};

export const LANGUAGE_CODE = {
  VI: "vi",
  MY: "my",
  ID: "id",
  EN: "en",
  NE: "ne",
  KM: "km",
};

export type TLanguageCode = valueOf<typeof LANGUAGE_CODE>;

export const CONVERT_DOCUMENT_STATUS = {
  IN_PROGRESS: "in_progress",
  COMPLETE: "complete",
  ERROR: "error",
  SKIP: "skip",
  CONVERTING: "converting",
  COMPLETED_CONVERT: "completed_convert",
};

export type TConvertDocumentStatus = valueOf<typeof CONVERT_DOCUMENT_STATUS>;

export const CONVERT_DOCUMENT_STATUS_LABEL = {
  [CONVERT_DOCUMENT_STATUS.COMPLETE]: "編集完了",
  [CONVERT_DOCUMENT_STATUS.IN_PROGRESS]: "未完了",
  [CONVERT_DOCUMENT_STATUS.ERROR]: "エラー",
  [CONVERT_DOCUMENT_STATUS.CONVERTING]: "変換中",
  [CONVERT_DOCUMENT_STATUS.COMPLETED_CONVERT]: "変換完了",
};

export const DOCUMENT_STATUS = {
  IN_PROGRESS: "in_progress",
  COMPLETE: "complete",
  CONVERTING: "converting",
  CONVERT_COMPLETE: "convert_complete",
  ERROR: "error",
  SKIP: "skip",
  COMPLETED_CONVERT: "completed_convert",
};

export const DOCUMENT_STATUS_LABEL = {
  [DOCUMENT_STATUS.IN_PROGRESS]: "未完了",
  [DOCUMENT_STATUS.COMPLETE]: "完了",
  [DOCUMENT_STATUS.CONVERTING]: "変換中",
  [DOCUMENT_STATUS.CONVERT_COMPLETE]: "完了",
  [DOCUMENT_STATUS.COMPLETED_CONVERT]: "完了",
  [DOCUMENT_STATUS.ERROR]: "エラー",
  [DOCUMENT_STATUS.SKIP]: "スキップ",
};

export enum EProductCode {
  VISA = "visa",
  // TODO: [match-phase] Restore MATCH when match integration is implemented.
  // MATCH = "match",
  // STUDY = "study",
  // CENTER = "center",
}

export enum EUserProductContractStatus {
  ACTIVE = "active",
  DE_ACTIVE = "de_active",
}

export enum EContractStatus {
  DURING_CONTRACT = "during_contract",
  CANCELED_CONTRACT = "canceled_contract",
  EXPIRED_CONTRACT = "expired_contract",
  TRIAL = "trial",
  TRIAL_CANCELLED = "trial_cancelled",
}
